<!-- Your existing HTML code -->
<!--<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">

<div class="table-container">
  <h4>{{ tableTitle }}</h4>
  <div class="search-container">
    <input type="text" class="search-input" placeholder="Search.." (keyup)="search($event)">
  </div>
  <div class="table-header">
    <table class="custom-table" #customTable>
      <thead #headerElement class="header">
        <tr>
          <th class="header-cell row-header sticky-col" rowspan="2">Row</th>
          <ng-container *ngFor="let header of headers">
            <th class="header-cell" colspan="2">{{ header }}</th>
          </ng-container>
        </tr>
        <tr>
          <ng-container *ngFor="let header of headers">
            <th class="header-cell">1</th>
            <th class="header-cell">2</th>
          </ng-container>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let rowKey of valuesArrayList | paginate: { itemsPerPage: 10, currentPage: p }; let i = index">
          <tr [class.even-row]="i % 2 === 0" [class.odd-row]="i % 2 !== 0" [class.first-row]="i==0" class="table-content">
            <td class="data-cell row-header sticky-col header" rowspan="2">{{ i + 1 }}</td>

            <ng-container *ngFor="let item of rowKey; let j = index">
              <td class="data-cell" rowspan="2">{{ item.substring(0, item.length / 2) }}</td>
              <td class="data-cell " rowspan="2">{{ item.substring(item.length / 2) }}</td>
            </ng-container>
          </tr>-->
<!-- The second row for the same set of data -->
<!--<tr [class.even-row]="i % 2 === 0" [class.odd-row]="i % 2 !== 0" [class.first-row]="i==0" class="table-content">-->
<!-- Empty cells since they are already covered by rowspan in the first row -->
<!--</tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="onTableDataChange($event)">
  </pagination-controls>
</div>-->
<!-- Your existing HTML code -->
<!--<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">

<div class="table-container">
  <h4>{{ tableTitle }}</h4>
  <div class="search-container">
    <input type="text" class="search-input" placeholder="Search.." (keyup)="search($event)">
  </div>
  <div class="table-header">
    <table class="custom-table" #customTable>
      <thead #headerElement class="header">
        <tr>
          <th class="header-cell row-header sticky-col" rowspan="2">Row</th>
          <th></th>
          <ng-container *ngFor="let header of headers">
            <th class="header-cell" colspan="2">{{ header }}</th>
          </ng-container>
        </tr>
        <tr>
          <th></th>
          <ng-container *ngFor="let header of headers">
            <th class="header-cell">First Half</th>
            <th class="header-cell">Second Half</th>
          </ng-container>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let rowKey of valuesArrayList | paginate: { itemsPerPage: 10, currentPage: p }; let i = index">
          <tr [class.even-row]="i % 2 === 0" [class.odd-row]="i % 2 !== 0" [class.first-row]="i==0" class="table-content">

            <td class="data-cell row-header sticky-col header" *ngIf="i % 2 === 0" [attr.rowspan]="2">Row{{ i / 2 + 1 }}</td>

            <ng-container *ngFor="let item of rowKey; let j = index">
              <td class="data-cell" >{{ item.substring(0, item.length / 2) }}</td>
              <td class="data-cell" >{{ item.substring(item.length / 2) }}</td>
            </ng-container>
          </tr>-->
<!-- The second row for the same set of data -->
<!--<tr [class.even-row]="i % 2 === 0" [class.odd-row]="i % 2 !== 0" [class.first-row]="i==0" class="table-content">-->
<!-- Empty cells since they are already covered by rowspan in the first row -->
<!--</tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="onTableDataChange($event)">
  </pagination-controls>
</div>-->

<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
<h4>{{ tableTitle }}</h4>

<!-- <div class="search-container">

  <input type="text" class="search-input" placeholder="Search.." (keyup)="search($event)">

</div> -->


<div class="table-preview" #customTable>
  <div class="preview-table-container" [ngStyle]="{'--custom-margin': getMarginForScroll()}">
    <div class="rows-left-header-block">
      <div class="empty-header" *ngIf="rowData.length > 0 || columnData.length > 0">
        <div class="empty-row-block"></div>
        <ng-container *ngIf="columnData[0].Data[0].children.length != 0">
          <div class="empty-col-nesting"  *ngFor="let colnesting of columnNestingData"></div>
        </ng-container>
      </div>
      <div class="table-rows-header-block">
        <ng-container *ngFor="let row of rowData">
          <div class="preview-rows">
            <div class="preview-row-header" [ngStyle]="{'background-color': properties.headerColor,'color':properties.headerTextColor}" *ngFor="let row_item of row.Data">
              <div class="preview-row-header-text" [ngStyle]="{'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}" [style.height.px]="getWidthofCellOnCount2(row_item,'row')"
                title="{{ row_item.name }}">
                <div class="row-col-header-title" [ngStyle]="{'text-align':properties.textAlign}">{{ row_item.name }}</div>
              </div>
              <ng-container *ngIf="row_item.children">
                <ng-container *ngFor="let rowNesting of rowNestingData;let ind=index">
                <div class="row-nesting-block" *ngFor="let rownesting of row.Data">
                  <ng-container *ngIf="ind == 0">
                      <div class="row-nest-header-block">
                        <div class="row-nest-header" [ngStyle]="{'border':(properties.borderStyle==0?'0px ':'1px ') + properties.borderStyle +' '+properties.border}" [style.height.px]="getNestingCount(ind,'rowData','RowNesting')" *ngFor="let nesting of rownesting.children">
                          <div class="row-nest-header-txt" [ngStyle]="{'text-align':properties.textAlign}" title="{{ nesting.name }}">{{ nesting.name }}</div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="ind > 0">
                      <div class="row-nest-header-block" *ngFor="let nesting of rownesting.children">
                        <div class="row-nest-header" [ngStyle]="{'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}" [style.height.px]="getNestingCount(ind,'rowData','RowNesting')" *ngFor="let nesting2 of nesting.children;let i =index">
                          <div class="row-nest-header-txt" [ngStyle]="{'text-align':properties.textAlign}" title="{{ nesting2.name }}">{{ nesting2.name }}</div>
                        </div>
                      </div>
                    </ng-container>
                </div>
               </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="column-body">
      <div class="preview-columns-header">
        <ng-container *ngIf="tableData['columnData']!=undefined">
          <div class="preview-row-header" [ngStyle]="{'background-color': properties.headerColor,'color':properties.headerTextColor}" *ngFor="let col of columnData">
            <div class="row-block" *ngFor="let col_item of col.Data">
              <div class="row-header-text" [ngStyle]="{'background-color': properties.headerColor,'color':properties.headerTextColor,'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}" [style.width.px]="getWidthofCellOnCount2(col_item,'column')">
                <div class="row-header-title" [ngStyle]="{'text-align':properties.textAlign}" title="{{col_item.name}}"> {{col_item.name}}</div>
              </div>
              <ng-container *ngIf="columnData[0].Data[0].children != undefined">
                <ng-container *ngFor="let columnNesting of columnNestingData;let ind=index">
                <div class="col-nesting-block" *ngFor="let colnesting of col.Data">
                  <ng-container *ngIf="ind==0">
                            <div class="col-nest-header-block">
                               <div class="col-nest-header" [ngStyle]="{'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}" [style.width.px]="getNestingCount(ind,'columnData','ColNesting')" *ngFor="let nesting of colnesting.children">
                               <div class="col-nest-header-txt" [ngStyle]="{'text-align':properties.textAlign}" title="{{nesting.name}}"> {{nesting.name}}</div>                          
                            </div>
                      </div>
                  </ng-container>
                  <ng-container *ngIf="ind>0">
                    <div class="col-nest-header-block"
                    *ngFor="let nesting of colnesting.children">
                    <div class="col-nest-header" [ngStyle]="{'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}" [style.width.px]="getNestingCount(ind,'columnData','ColNesting')"
                      *ngFor="let nesting2 of nesting.children;let i=index">
                      <div class="col-nest-header-txt" [ngStyle]="{'text-align':properties.textAlign}" title="{{nesting2.name}}">{{nesting2.name}}</div>
                    </div>
                  </div>
                  </ng-container>
                </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="preview-table-body">
          <ng-container *ngFor="let row of rowData">
            <ng-container *ngFor="let row_item of row.Data">
              <ng-container *ngIf="row_item.children.length > 0">
              <ng-container *ngFor="let rowNesting of row_item.children">
                <ng-container *ngIf="rowNesting.children.length > 0">
                  <ng-container *ngFor="let rowNesting2 of rowNesting.children">
                   <div class="row-data-container" [ngClass]="{'row-data-alternative':properties.alternateColor}">
                      <ng-container *ngFor="let col of columnData">
                        <ng-container *ngFor="let col_item of col.Data">
                          <ng-container *ngIf="col_item.children.length > 0">
                            <ng-container *ngFor="let colNesting of col_item.children">
                              <ng-container *ngIf="colNesting.children.length > 0">
                                <ng-container *ngFor="let colNesting2 of colNesting.children">
                                <div class="row-cell-block" [ngStyle]="{'background-color': properties.darkTheme ?tableService.darkThemeBackgroundColor: properties.cellColor,'color': properties.darkTheme ? tableService.darkThemeTextColor : properties.datalabelcolor,'border':(properties.borderStyle==0?'5px ':'1px ')+ properties.borderStyle +' '+properties.border}">
                                      <div class="cell-data" [ngStyle]="{'text-align':properties.textAlign}" [innerHTML]="getValueLevel2ColRowNesting(row_item.name, col_item.name, rowNesting.name, colNesting.name,rowNesting2.name,colNesting2.name)"></div>
                                </div>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngIf="colNesting.children.length === 0">
                                <div class="row-cell-block" [ngStyle]="{'background-color': properties.darkTheme ?tableService.darkThemeBackgroundColor: properties.cellColor,'color': properties.darkTheme ? tableService.darkThemeTextColor : properties.datalabelcolor,'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}">
                                      <div class="cell-data" [ngStyle]="{'text-align':properties.textAlign}" [innerHTML]="getValueLevel2RowNesting(row_item.name, col_item.name, rowNesting.name,colNesting.name,rowNesting2.name)"></div>
                                </div>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngIf="col_item.children.length === 0">
                                <div class="row-cell-block" [ngStyle]="{'background-color': properties.darkTheme ?tableService.darkThemeBackgroundColor: properties.cellColor,'color': properties.darkTheme ? tableService.darkThemeTextColor : properties.datalabelcolor,'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}">
                                      <div class="cell-data" [ngStyle]="{'text-align':properties.textAlign}" [innerHTML]="getValueRowNestingOnly(row_item.name,col_item.name,rowNesting.name,rowNesting2.name)"></div>
                                </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                   </div>
                  </ng-container>
                </ng-container> 
                <ng-container *ngIf="rowNesting.children.length === 0">              
                   <div class="row-data-container" [ngClass]="{'row-data-alternative':properties.alternateColor}">
                      <ng-container *ngFor="let col of columnData">
                        <ng-container *ngFor="let col_item of col.Data">
                          <ng-container *ngIf="col_item.children.length > 0">
                            <ng-container *ngFor="let colNesting of col_item.children">
                              <ng-container *ngIf="colNesting.children.length > 0">
                                <ng-container *ngFor="let colNesting2 of colNesting.children">
                                <div class="row-cell-block" [ngStyle]="{'background-color': properties.darkTheme ?tableService.darkThemeBackgroundColor: properties.cellColor,'color': properties.darkTheme ? tableService.darkThemeTextColor : properties.datalabelcolor,'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+ properties.border}">
                                      <div class="cell-data" [ngStyle]="{'text-align':properties.textAlign}" [innerHTML]="getValueLevel2ColRowNesting(row_item.name, col_item.name, rowNesting.name, colNesting.name,null,colNesting2.name)"></div>
                                </div>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngIf="colNesting.children.length === 0">
                                <div class="row-cell-block" [ngStyle]="{'background-color': properties.darkTheme ?tableService.darkThemeBackgroundColor: properties.cellColor,'color': properties.darkTheme ? tableService.darkThemeTextColor : properties.datalabelcolor,'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}">
                                      <div class="cell-data" [ngStyle]="{'text-align':properties.textAlign}" [innerHTML]="getValueLevel2RowNesting(row_item.name, col_item.name, rowNesting.name,colNesting.name,null)"></div>
                                </div>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngIf="col_item.children.length === 0">
                                <div class="row-cell-block" [ngStyle]="{'background-color': properties.darkTheme ?tableService.darkThemeBackgroundColor: properties.cellColor,'color': properties.darkTheme ? tableService.darkThemeTextColor : properties.datalabelcolor,'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}">
                                      <div class="cell-data" [ngStyle]="{'text-align':properties.textAlign}" [innerHTML]="getValueRowNestingOnly(row_item.name,col_item.name,rowNesting.name,null)"></div>
                                </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                   </div>
                </ng-container> 
              </ng-container>
              </ng-container>
              <ng-container *ngIf="row_item.children.length === 0">
                     <div class="row-data-container" [ngClass]="{'row-data-alternative':properties.alternateColor}">
                        <ng-container *ngFor="let col of columnData">
                          <ng-container *ngFor="let col_item of col.Data">
                            <ng-container *ngIf="col_item.children.length > 0">
                             <ng-container *ngFor="let colNesting of col_item.children">
                              <ng-container *ngIf="colNesting.children.length > 0">
                                <ng-container *ngFor="let colNesting2 of colNesting.children">
                                  <div class="row-cell-block" [ngStyle]="{'background-color': properties.darkTheme ?tableService.darkThemeBackgroundColor: properties.cellColor,'color': properties.darkTheme ? tableService.darkThemeTextColor : properties.datalabelcolor,'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}">
                                        <div class="cell-data" [ngStyle]="{'text-align':properties.textAlign}" [innerHTML]="getValueColumnNestingOnly(row_item.name,col_item.name,colNesting.name,colNesting2.name)"></div>
                                  </div>
                                </ng-container>
                              </ng-container>    
                              <ng-container *ngIf="colNesting.children.length === 0">
                                <div class="row-cell-block" [ngStyle]="{'background-color': properties.darkTheme ?tableService.darkThemeBackgroundColor: properties.cellColor,'color': properties.darkTheme ? tableService.darkThemeTextColor : properties.datalabelcolor,'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}">
                                      <div class="cell-data" [ngStyle]="{'text-align':properties.textAlign}" [innerHTML]="getValueColumnNestingWithoutRowNesting(row_item.name, col_item.name,colNesting.name)"></div>
                                </div>
                              </ng-container>
                             </ng-container>
                            </ng-container>
                            <ng-container *ngIf="col_item.children.length === 0">
                                   <div class="row-cell-block" [ngStyle]="{'background-color': properties.darkTheme ?tableService.darkThemeBackgroundColor: properties.cellColor,'color': properties.darkTheme ? tableService.darkThemeTextColor : properties.datalabelcolor,'border':(properties.borderStyle==0?'0px ':'1px ')+ properties.borderStyle +' '+properties.border}">
                                         <div class="cell-data" [ngStyle]="{'text-align':properties.textAlign}" [innerHTML]="getValueWithoutNesting(row_item.name,col_item.name)"></div>
                                   </div>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                     </div>
              </ng-container>
            </ng-container>
          </ng-container>
      </div> 
    </div>
  </div>
</div>